import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Organitzation, User } from "@nousmedis/guard-types/frontend";
import { AuthModel } from "@nousmedis/nm-guard-auth";

@Injectable({
  providedIn: "root",
})
export class UserService {
  userChanged: Subject<boolean> = new Subject<boolean>();
  logoOut: Subject<boolean> = new Subject<boolean>();
  user$: Subject<User | undefined> = new Subject<User | undefined>();
  currentOrg$: Subject<Organitzation | undefined> = new Subject<Organitzation | undefined>();
  orgsOfUser$: Subject<Organitzation[]> = new Subject<Organitzation[]>();

  org: Organitzation | undefined;
  user: User | undefined;

  constructor(private auth: AuthModel) {}

  getCurrentUser(): any | undefined {
    return this.auth.getCurrentUser();
  }

  getToken(): string | undefined {
    return this.auth.getToken() ?? undefined;
  }

  setCurrentOrg(org: Organitzation) {
    this.org = org;
    this.currentOrg$.next(org);
  }

  setOrgs(orgs: Organitzation[]) {
    this.orgsOfUser$.next(orgs);
  }

  logOut(user: User) {
    this.auth.logOut(user);
    this.user = undefined;
    this.user$.next(undefined);
  }

  hasDefaultOrg() {
    return false;
  }

  hasOrgs() {
    return false;
  }
}
